import { render, staticRenderFns } from "./SearchVet.vue?vue&type=template&id=3129ace0&"
import script from "./SearchVet.vue?vue&type=script&lang=js&"
export * from "./SearchVet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports